import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import "./MenuBar.css";
import AdminPanel from '../AdminPanel/AdminPanel';
import DataUpload from '../Popup/DataUpload/DataUpload';
import AddProjectGroup from '../Popup/AddProjectGroup/AddProjectGroup';
import Create_Project_icon from '../../Images/utilImages/Create_Project_icon.png'
import { useAuth } from '../../context/AuthContext'; // ✅ AuthContext 불러오기
import ProjectGroup from '../ProjectGroup/ProjectGroup';



const MenuBar = ({ activeTab, setActiveTab, setAdminSubTab }) => {
  const { t } = useTranslation('menubar');
  const { userRole } = useAuth(); // ✅ 현재 로그인된 사용자 role 가져오기
  const [showUpload, setShowUpload] = useState(false);
  const [showCreateProject, setShowCreateProject] = useState(false);
  const [refreshProjectGroups, setRefreshProjectGroups] = useState(false); // ✅ 트리거 상태

  const handleToggle = () => {
    setShowUpload((prev) => !prev); // 클릭할 때마다 true/false 반전
  };

  return (
    <div className='Basic_Menubar'>
      {/* 탭 영역 (가로 정렬) */}
      <div className='tabContainer'>
        <div
          className={`tab ${activeTab === 'dataset' ? 'active' : ''}`}
          onClick={() => setActiveTab('dataset')}
        >
          {t("header.tab1")}
        </div>
         {/* ✅ ROLE_ADMIN일 때만 운영 관리 탭 보이기 */}
         {['ROLE_ADMIN', 'ROLE_SUPERUSER'].includes(userRole) && (
          <div
            className={`tab ${activeTab === 'admin' ? 'active' : ''}`}
            onClick={() => setActiveTab('admin')}
          >
            {t("header.tab2")}
          </div>
        )}

      </div>

      {/* 콘텐츠 영역 */}
      <div className='datacontainer'>
        {activeTab === 'dataset' && <ProjectGroup  refreshProjectGroups={refreshProjectGroups} setRefreshProjectGroups={setRefreshProjectGroups}/>}
        {activeTab === 'admin' && (userRole === 'ROLE_ADMIN' || userRole === 'ROLE_SUPERUSER') && (
            <AdminPanel setAdminSubTab={setAdminSubTab} />
          )}
      </div>

      {/* 하단 업로드 버튼 */}
      <div className='uploadcontainer'>
      {activeTab === 'dataset' && 
        <div className='uploadbox' onClick={() => setShowCreateProject(true)}>{t("projectgroup.create")}</div>
      }
        
      </div>
      {/* showUpload가 true일 때만 DataUpload 보이기 */}
      {showUpload && 
      <div className='PopupContainer'>
        <DataUpload setShowUpload={setShowUpload}/>
      </div>
     }
     {showCreateProject && (
        <div className="PopupContainer">
          <AddProjectGroup setShowCreateProject={setShowCreateProject} 
          onSuccess={() => setRefreshProjectGroups(prev => !prev)} // ✅ 성공 시 토글
          />
        </div>
      )}
    </div>
  );
};

export default MenuBar;
